import { apiGet } from "../../shared/api";

const ROTTA = "/api/economics/fatture-fornitori";

/** Una fattura di acquisto dall'archivio Eureka. Importi in STRINGA: arrivano
 *  da Decimal, un float perderebbe esattezza. */
export type FatturaFornitore = {
  id: number;
  fornitore: string;
  piva: string;
  tipo: string;
  tipo_nome: string;
  numero: string;
  data: string;
  imponibile: string | null;
  totale: string | null;
  righe: number;
  /** Gli ordini OM a cui sono legate le righe (numero ordine del canale). */
  ordini: string[];
};

export type ElencoFattureFornitori = {
  totale: number;
  fatture: FatturaFornitore[];
  fornitori: Array<{ piva: string; nome: string; fatture: number }>;
  ultimo_import: string | null;
};

export type RigaFatturaFornitore = {
  riga: number;
  codice: string;
  descrizione: string;
  quantita: string;
  importo: string;
  rif_ordine: string;
  ordine: string | null;
};

export type Filtri = { cerca?: string; piva?: string; dal?: string; al?: string; offset?: number };

export const PER_PAGINA = 100;

export function fetchFattureFornitori(
  filtri: Filtri,
  signal?: AbortSignal,
): Promise<ElencoFattureFornitori> {
  const q = new URLSearchParams({ limite: String(PER_PAGINA) });
  for (const [k, v] of Object.entries(filtri)) {
    if (v !== undefined && v !== "") q.set(k, String(v));
  }
  return apiGet(`${ROTTA}?${q.toString()}`, signal ? { signal } : undefined);
}

export function fetchRigheFattura(id: number): Promise<{ righe: RigaFatturaFornitore[] }> {
  return apiGet(`${ROTTA}/${id}`);
}

/** Una riga di un controllo: importi in stringa (Decimal), null = non pertinente. */
export type RigaControllo = {
  ordine: string | null;
  chi: string;
  documento: string;
  data: string | null;
  atteso: string | null;
  trovato: string | null;
  differenza: string | null;
  nota: string;
};

export type GruppoControllo = {
  chiave: string;
  parte: "fornitori" | "clienti";
  titolo: string;
  spiegazione: string;
  /** «errore» = da correggere; «da_guardare» = puo' essere giusto, va visto. */
  gravita: "errore" | "da_guardare";
  righe: RigaControllo[];
};

export type ControlliFatture = {
  /** Fino a che data sono stati letti gli archivi (scarico Eureka a mano). */
  letti_fino_al: Record<string, string | null>;
  gruppi: GruppoControllo[];
};

export function fetchControlli(signal?: AbortSignal): Promise<ControlliFatture> {
  return apiGet(`${ROTTA}/controlli`, signal ? { signal } : undefined);
}
